import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { AxiosError } from 'axios';
import { Link, useParams } from 'react-router-dom';

import { useGetPageReport } from '../api/getReport';
import { ReportCard } from '../components/ReportCard';

import { ListLoader, ServerError } from '@/components';

function isNotFoundError(error: unknown): boolean {
  return error instanceof AxiosError && error.response?.status === 404;
}

export const AiReportPage = () => {
  const { reportId = '' } = useParams();
  const reportQuery = useGetPageReport({ reportId });

  if (reportQuery.isLoading) return <ListLoader />;

  if (reportQuery.isError && isNotFoundError(reportQuery.error)) {
    return (
      <Center h="50vh">
        <Stack align="center" gap="md">
          <Title order={3}>Отчёт не найден</Title>
          <Text c="dimmed" ta="center" maw={360}>
            Отчёт не существует или у вас нет доступа к нему
          </Text>
          <Button component={Link} to="/ai-reports" variant="light">
            К списку отчётов
          </Button>
        </Stack>
      </Center>
    );
  }

  if (reportQuery.isError || !reportQuery.data) {
    return (
      <ServerError onRetry={() => reportQuery.refetch()} isFetching={reportQuery.isFetching} />
    );
  }

  return (
    <Stack p="md">
      <ReportCard
        report={reportQuery.data.report}
        batch={reportQuery.data.batch}
        receivedAt={reportQuery.dataUpdatedAt}
      />
    </Stack>
  );
};
